// ======================================================================
// File Name       : AuthorityRegistUpdateForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import $ from 'jquery';
import { getAuthorityList, authorityEdit } from '../../actions/AuthorityAction';
import { MODAL_SIZE, SELECT_TARGET_DATA, MODE, RETURN_MAX_NUM, USAGE_SETTING } from '../../constants/index';
import {
  GUIDELINE_AUTHORITY,
  AUTHORITY_PRESET_DEFAULT,
  SCORING_MANAGEMENT_AUTHORITY_TYPE,
  USER_AUTHORITY_ROLE,
  LIVE_MANAGEMENT_AUTHORITY_TYPE,
  MANAGEMENT_AUTHORITY_TYPE,
  MANAGEMENT_AUTHORITY_DISPLAY_TYPE,
} from '../../constants/AuthorityConstant';
import { AUTHORITY, AUTHORITY_LIST } from '../../constants/PathConstants';
import FormControlValidate from '../../components/FormControlValidate';
import AboutAuthorityDialog from '../../components/authority/AboutAuthorityDialog';
import AuthorityManagementFunction from '../../components/authority/AuthorityManagementFunction';
import AuthorityRegisterEditConfirm from '../../components/authority/AuthorityRegisterEditConfirm';
import Header from '../../components/Header';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';
import AuthorityManagementFunctionDisplay from '../../components/authority/AuthorityManagementFunctionDisplay';

class AuthorityRegisterEditContainer extends React.Component {
  /**
     * The constructor of component
     * @param {*} props
     */
  constructor(props) {
    super(props);
    this.authorityDefault = {
      managementAuthoritySecernId: '',
      managementAuthorityName: '',
      // Step 10.0.0 START
      managementFunctionAuthorityInfo: {
        userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
      },
      managementFunctionAuthorityDisplayInfo: {
        userManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        groupManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        courseManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        contentManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        achievementManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        scoringManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        messageManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        noticeManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        emailManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        liveManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        userfrontManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        performanceManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        authorityManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
        materialManagementAuthorityDisplay: MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE,
      },
      // Step 10.0.0 END
    };
    this.authorityAdmin = null;
    this.authorityTeacher = null;
    this.authorityScorer = null;
    this.state = {
      mode: MODE.NEW_MODE,
      authority: { ...this.authorityDefault },
      defaultChecked: AUTHORITY_PRESET_DEFAULT.DEFAULT,
      showModalConfirm: false,
      showAboutDialog: false,
      isDisabledSettingDisplay: false,
    };
    this.handleAuthorityChange = this.handleAuthorityChange.bind(this);
    this.handleManagementFunctionAuthorityChange = this.handleManagementFunctionAuthorityChange.bind(
      this,
    );
    this.handleDefaultPresetChange = this.handleDefaultPresetChange.bind(this);
    this.openRegistUpdateConfirmDialog = this.openRegistUpdateConfirmDialog.bind(this);
    this.onRegistUpdateOk = this.onRegistUpdateOk.bind(this);
    this.onRegistUpdateCancel = this.onRegistUpdateCancel.bind(this);
    this.openAuthorityAboutDialog = this.openAuthorityAboutDialog.bind(this);
    this.onAuthorityAboutOk = this.onAuthorityAboutOk.bind(this);
    this.handleManagementFunctionAuthorityDisplayChange = this.handleManagementFunctionAuthorityDisplayChange.bind(this);
    this.getManagementFuntionAuthorityDefaultPreset = this.getManagementFuntionAuthorityDefaultPreset.bind(this);
    this.backPage = this.backPage.bind(this);
  }

  /**
     * Life cycle function of component
     */
  componentWillMount() {
    const { authority, match, history, authed } = this.props;
    const { authorityInfo } = authority;
    const { authedUser: { usageSettingLive } } = authed;
    if (authorityInfo.managementAuthorityList.length === 0) {
        //  Back to authority top
      history.push(AUTHORITY_LIST);
    } else {
      for (const curr of authorityInfo.managementAuthorityList) {
        if (match.params.id && curr.managementAuthoritySecernId === match.params.id) {
          this.setState({
            mode: MODE.EDIT_MODE,
            authority: curr,
          });
        }
        if (curr.managementAuthoritySecernId === USER_AUTHORITY_ROLE.ADMIN) {
          this.authorityAdmin = curr;
        } else if (curr.managementAuthoritySecernId === USER_AUTHORITY_ROLE.TEACHER) {
          this.authorityTeacher = curr;
        } else if (curr.managementAuthoritySecernId === USER_AUTHORITY_ROLE.SCORING_MANAGEMENT) {
          this.authorityScorer = curr;
        }
      }
    }
    // Step 10.0.0 START
    if (usageSettingLive === USAGE_SETTING.UN_USE) {
      this.state.authority.managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay = MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
      this.setState({ isDisabledSettingDisplay: true });
    }
    // Step 10.0.0 END
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { authority, match } = nextProps;
    if (authority) {
      const { authorityInfo } = authority;
      if (!authorityInfo) return;
      for (const curr of authorityInfo.managementAuthorityList) {
        if (match.params.id && curr.managementAuthoritySecernId === match.params.id) {
          this.setState({
            mode: MODE.EDIT_MODE,
            authority: curr,
          });
        }
        if (curr.managementAuthoritySecernId === USER_AUTHORITY_ROLE.ADMIN) {
          this.authorityAdmin = curr;
        } else if (curr.managementAuthoritySecernId === USER_AUTHORITY_ROLE.TEACHER) {
          this.authorityTeacher = curr;
        } else if (curr.managementAuthoritySecernId === USER_AUTHORITY_ROLE.SCORING_MANAGEMENT) {
          this.authorityScorer = curr;
        }
      }
    }
  }

  /**
   * Open dialog regist update confirm dialog
   */
  openRegistUpdateConfirmDialog() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({ showModalConfirm: true });
    }
  }

  /**
   * Event click button ok in confirm dialog
   */
  onRegistUpdateOk() {
    this.setState({
      showModalConfirm: false,
    });
    const { authority, mode } = this.state;
    const param = {
      editType: mode,
      managementAuthorityInfo: {...authority }, // Step 10.0.0
    };

    const targetAuthority = { ...authority };
    const { managementFunctionAuthorityDisplayInfo, managementFunctionAuthorityInfo} = targetAuthority;
    // Step 10.0.0 START
    if (param.managementAuthorityInfo && param.managementAuthorityInfo.managementFunctionAuthorityDisplayInfo) {
      // check in 画面表示 is 表示 or 非表示, in case of 非表示, set 0 as default value
      const resultManagementAuthorityInfo = Object.keys(managementFunctionAuthorityDisplayInfo).reduce((acc, cur) => {
        const targetName = cur.replace("Display", '');
        acc[targetName] = managementFunctionAuthorityDisplayInfo[cur] > 0 ? managementFunctionAuthorityInfo[targetName] : 0;
        return acc;
      }, {});
      param.managementAuthorityInfo.managementFunctionAuthorityInfo = resultManagementAuthorityInfo;

      // delete in param to make sure not send in request
      delete param.managementAuthorityInfo.managementFunctionAuthorityDisplayInfo;
    }
    // Step 10.0.0 END
    const { history } = this.props;
    this.props.dispatch(authorityEdit(param)).then(() => {
      //  Back to authority top
      history.push(AUTHORITY_LIST);
    });
  }

  /**
   * Event click button cancel in confirm dialog
   */
  onRegistUpdateCancel() {
    this.setState({
      showModalConfirm: false,
    });
  }

  // Step 10.0.0 START
  getManagementFuntionAuthorityDefaultPreset(value) {
    let managementFunctionAuthorityInfo = '';
    switch (value) {
      case AUTHORITY_PRESET_DEFAULT.DEFAULT:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        };
        break;
      case AUTHORITY_PRESET_DEFAULT.ADMIN:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING_APPROVAL,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
        };
        break;
      case AUTHORITY_PRESET_DEFAULT.TEACHER:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE,
        };
        break;
      case AUTHORITY_PRESET_DEFAULT.SCORER:
        managementFunctionAuthorityInfo = {
          userManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          groupManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          courseManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          contentManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          achievementManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          scoringManagementAuthority: SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING,
          messageManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          noticeManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          emailManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT,
          liveManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          userfrontManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          performanceManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          authorityManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
          materialManagementAuthority: MANAGEMENT_AUTHORITY_TYPE.NOT_USED,
        };
        break;
      default:
        break;
    }
    return managementFunctionAuthorityInfo;
  }
  // Step 10.0.0 END

  /**
     * Event select radio button preset default
     * @param {*} event
     */
  handleDefaultPresetChange(event) {
    const value = parseInt(event.target.value, 10);
    const authority = { ...this.state.authority };
    const { authedUser: { usageSettingLive } } = this.props.authed;

    // Step 10.0.0 START
    authority.managementFunctionAuthorityInfo = this.getManagementFuntionAuthorityDefaultPreset(value);
    const authorityDisplayMapping = Object.keys(authority.managementFunctionAuthorityInfo).reduce((acc, cur) => {
      acc[`${cur}Display`] =
        authority.managementFunctionAuthorityInfo[cur] > 0
          ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
          : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
      return acc;
   }, {});

    authority.managementFunctionAuthorityDisplayInfo = {
      ...authorityDisplayMapping,
    }
    if (usageSettingLive === USAGE_SETTING.UN_USE) {
      authority.managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay = MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
    }
    // Step 10.0.0 END

    this.setState({
      authority,
      defaultChecked: value,
    });
  }

  /**
     * Handle change authority name
     * @param {*} event
     */
  handleAuthorityChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    const authority = this.state.authority;
    authority[name] = value;
    this.setState({ authority });
  }

  /**
     * Handle change radio button function authority
     * @param {*} event
     */
  handleManagementFunctionAuthorityChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    const authority = this.state.authority;
    authority.managementFunctionAuthorityInfo[name] = parseInt(value, 10);
    this.setState({ authority });
  }

  // Step 10.0.0 START
  handleManagementFunctionAuthorityDisplayChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    const authority = this.state.authority;
    const targetValue = parseInt(value, 10)
    authority.managementFunctionAuthorityDisplayInfo[name] = targetValue;

    // set selected value if user change 非表示 to 表示
    if (targetValue === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY) {
      const targetAuthorityPermission = name.replace('Display', '');
      let authorityTargetValue = '';
      if (targetAuthorityPermission === 'materialManagementAuthority'
        || targetAuthorityPermission === 'achievementManagementAuthority'
        || targetAuthorityPermission === 'performanceManagementAuthority') {
        authorityTargetValue = MANAGEMENT_AUTHORITY_TYPE.REFERENCE;
      } else {
        authorityTargetValue = MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT;
      }
      authority.managementFunctionAuthorityInfo[targetAuthorityPermission] = authorityTargetValue;
    }
    this.setState({ authority });
  }
  // Step 10.0.0 END

  /**
     * Show more information when click
     */
  openAuthorityAboutDialog() {
    this.setState({ showAboutDialog: true });
  }

  onAuthorityAboutOk() {
    this.setState({ showAboutDialog: false });
  }

  backPage() {
    this.props.history.goBack();
  }

  /**
     * Render function of component
     */
  render() {
    const isNewMode = this.state.mode === MODE.NEW_MODE;
    const { isDisabledSettingDisplay } = this.state;
    const {
      managementAuthoritySecernId,
      managementAuthorityName,
      managementFunctionAuthorityInfo,
      managementFunctionAuthorityDisplayInfo,
    } = this.state.authority;
    this.refsToValidate = [];
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.AUTHORITY_LIST}
          text="ロール一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={isNewMode ? 'ロールの追加' : 'ロールの編集'} />
        <Form onSubmit={(e)=> { e.preventDefault(); this.openRegistUpdateConfirmDialog(); }} className='form-horizontal'>
          <Form.Group className="margin-top-10">
            <Col sm={7}>
              <h4>
                {isNewMode ? '登録する項目を指定してください。' : '編集する項目を指定してください。'}
              </h4>
            </Col>
            <Col sm={5}>
              <a href="#" onClick={this.openAuthorityAboutDialog}>
                <u>各管理ユーザー画面のロールについて</u>
              </a>
            </Col>
            <Col sm={12} as={Form.Label} className="margin-top-10 padding-left-clear">
              <h4>
                プリセットを元に編集することも可能です。
              </h4>
            </Col>
          </Form.Group>
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                プリセット
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="なし"
                  id="authority-default-0"
                  value={0}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.DEFAULT}
                  onChange={this.handleDefaultPresetChange}
                  label='なし'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="管理者"
                  id="authority-default-1"
                  value={1}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.ADMIN}
                  onChange={this.handleDefaultPresetChange}
                  label='管理者'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="講師"
                  id="authority-default-2"
                  value={2}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.TEACHER}
                  onChange={this.handleDefaultPresetChange}
                  label='講師'></Form.Check>
              </Col>
              <Col sm={2} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear"
                  name="採点者"
                  id="authority-default-3"
                  value={3}
                  checked={this.state.defaultChecked === AUTHORITY_PRESET_DEFAULT.SCORER}
                  onChange={this.handleDefaultPresetChange}
                  label='採点者'></Form.Check>
              </Col>
            </Form.Group>

            <hr className="break-line margin-top-10 margin-left-right-15" />
            <hr className="break-line margin-bottom-10 margin-left-right-15" />

            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                ロール名<span className="required">&nbsp;(※)</span>
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  label="ロール名"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  name="managementAuthorityName"
                  value={managementAuthorityName}
                  onChange={this.handleAuthorityChange}
                  type="text"
                  maxLength="64"
                />
              </Col>
            </Form.Group>

            <Form.Group>
              <Col sm={12} className="padding-bottom-10 margin-left-15">
                <p>画面表示</p>
              </Col>
              <Col sm={12} className="padding-left-50">
                <Form.Group>
                  <Col sm={12}>
                    <AuthorityManagementFunctionDisplay
                      label="ユーザー管理"
                      name="userManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="ユーザーグループ設定"
                      name="groupManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="コース"
                      name="courseManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="ビデオ/ドキュメント/リンク/ドリル"
                      name="contentManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="学習履歴"
                      name="achievementManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="添削管理"
                      name="scoringManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="メッセージ管理"
                      name="messageManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="お知らせ"
                      name="noticeManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="メール連絡"
                      name="emailManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="ライブ"
                      name="liveManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                      isDisabled={isDisabledSettingDisplay}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="受講ユーザー画面設定"
                      name="userfrontManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="システム利用実績管理"
                      name="performanceManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="ロール設定"
                      name="authorityManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.authorityManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                    <AuthorityManagementFunctionDisplay
                      label="TOP画面ダウンロードボタン"
                      name="materialManagementAuthorityDisplay"
                      value={managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay}
                      onChange={this.handleManagementFunctionAuthorityDisplayChange}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group>
              <Col sm={12} className="padding-bottom-10 margin-left-15">
                <p>権限設定</p>
              </Col>
              <Col sm={12} className="padding-left-50">
                <Form.Group>
                  <Col sm={12}>
                    <AuthorityManagementFunction
                      label="ユーザー管理"
                      name="userManagementAuthority"
                      value={managementFunctionAuthorityInfo.userManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="ユーザーグループ設定"
                      name="groupManagementAuthority"
                      value={managementFunctionAuthorityInfo.groupManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="コース"
                      name="courseManagementAuthority"
                      value={managementFunctionAuthorityInfo.courseManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="ビデオ/ドキュメント/リンク/ドリル"
                      name="contentManagementAuthority"
                      value={managementFunctionAuthorityInfo.contentManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="学習履歴"
                      name="achievementManagementAuthority"
                      value={managementFunctionAuthorityInfo.achievementManagementAuthority}
                      notRegisterEdit
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="添削管理"
                      name="scoringManagementAuthority"
                      value={managementFunctionAuthorityInfo.scoringManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="メッセージ管理"
                      name="messageManagementAuthority"
                      value={managementFunctionAuthorityInfo.messageManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="お知らせ"
                      name="noticeManagementAuthority"
                      value={managementFunctionAuthorityInfo.noticeManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="メール連絡"
                      name="emailManagementAuthority"
                      value={managementFunctionAuthorityInfo.emailManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="ライブ"
                      name="liveManagementAuthority"
                      value={managementFunctionAuthorityInfo.liveManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      // Step10.0.0 START
                      isDisabled={
                        managementFunctionAuthorityDisplayInfo.liveManagementAuthorityDisplay ===
                          MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE ||
                        isDisabledSettingDisplay
                      }
                      // Step10.0.0 END
                    />
                    <AuthorityManagementFunction
                      label="受講ユーザー画面設定"
                      name="userfrontManagementAuthority"
                      value={managementFunctionAuthorityInfo.userfrontManagementAuthority}
                      notReference
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="システム利用実績管理"
                      name="performanceManagementAuthority"
                      value={managementFunctionAuthorityInfo.performanceManagementAuthority}
                      notRegisterEdit
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <AuthorityManagementFunction
                      label="ロール設定"
                      name="authorityManagementAuthority"
                      value={managementFunctionAuthorityInfo.authorityManagementAuthority}
                      onChange={this.handleManagementFunctionAuthorityChange}
                      isDisabled={managementFunctionAuthorityDisplayInfo.authorityManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                    />
                    <Form.Group className="form-info">
                      <Col sm={3} as={Form.Label}>
                        TOP画面ダウンロードボタン
                      </Col>
                      <Col lg={5} sm={3} className="padding-top-10">
                        <Form.Check
                          type='radio'
                          inline
                          className="padding-top-clear"
                          name="materialManagementAuthority"
                          id="materialManagementAuthority"
                          value={MANAGEMENT_AUTHORITY_TYPE.REFERENCE}
                          checked={
                            managementFunctionAuthorityInfo.materialManagementAuthority ===
                            MANAGEMENT_AUTHORITY_TYPE.REFERENCE
                          }
                          onChange={this.handleManagementFunctionAuthorityChange}
                          disabled={managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
                          label='ダウンロード可'></Form.Check>
                      </Col>
                    </Form.Group>
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group className="margin-top-50 text-center">
              <Col sm={12} className="text-center">
                {!isNewMode &&
                  <Button variant="default" className="btn btn-default btn-96" onClick={this.backPage.bind(this)}>
                    キャンセル
                  </Button>
                }
                <Button
                  variant="primary"
                  className="margin-left-10 margin-left-10 btn-96"
                  type="submit"
                >
                  OK
                </Button>
              </Col>
            </Form.Group>
          </Col>
        </Form>
        <AuthorityRegisterEditConfirm
          showModal={this.state.showModalConfirm}
          size={MODAL_SIZE.lg}
          authority={this.state.authority}
          onRegisterEditOk={this.onRegistUpdateOk}
          onRegisterEditCancel={this.onRegistUpdateCancel}
        />
        <AboutAuthorityDialog
          showModal={this.state.showAboutDialog}
          onAuthorityAboutOk={this.onAuthorityAboutOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ authority: state.authority, authed: state.authed },
});

export default connect(mapStateToProps)(AuthorityRegisterEditContainer);
